const ParamPlugin = {
  install (Vue, options) {
    // /////////////////////
    // https://account.chekt.com/login;hl=en;service=email;continue=aHR0cHM6Ly9kZWFsZXIuY2hla3QuY29t;
    // ;hl=en;service=email;continue=aHR0cHM6Ly9kZWFsZXIuY2hla3QuY29t
    // ;access_token=eyJlbWFpbCI6InRyZXZvcnNAY2hla3QuY29tIiwiaXNfcmVzZXRfcGFzc3dvcmQiOnRydWUsImlzX3NpZ25lZHVwIjp0cnVlfQ
    // {
    //   "email": "trevors@chekt.com",
    //   "is_reset_password": true,
    //   "is_signedup": true
    // }
    // ;access_token=eyJlbWFpbCI6InRyZXZvcnNAY2hla3QuY29tIiwicmVxdWVzdCI6ImRlYWxlcl9yZWdpc3RyYXRpb24iLCJpc19yZXNldF9wYXNzd29yZCI6dHJ1ZSwiaXNfc2lnbmVkdXAiOnRydWV9
    // {
    //   "email": "trevors@chekt.com",
    //   "request": "dealer_registration",
    //   "is_reset_password": true,
    //   "is_signedup": true
    // }
    // ;hl=en;service=email;continue=aHR0cHM6Ly9kZWFsZXIuY2hla3QuY29t;access_token=eyJlbWFpbCI6InRyZXZvcnNAY2hla3QuY29tIiwicmVxdWVzdCI6ImRlYWxlcl9yZWdpc3RyYXRpb24iLCJpc19yZXNldF9wYXNzd29yZCI6dHJ1ZSwiaXNfc2lnbmVkdXAiOnRydWV9;
    // /////////////////////
    let param = {
      options: {},
      checkCHeKTParams: function () {
        return new Promise((resolve, reject) => {
          let pathname = window.location.pathname
          let itemList = pathname.split(';')
          // there is ';' separated param to be corrected.
          if (itemList.length > 1) {
            let options = this.parseNGStyleParamIntoOptions()
            if (options) {
              pathname = itemList[0] + '?options=' + options + window.location.search.replace('?', '&')
              window.location.replace(window.location.origin + pathname)
              resolve('Param replaced')
            }
          }
          reject(new Error('No param to replace'))
        })
      },
      parseNGStyleParamIntoOptions: function () {
        // All params
        let params = {}
        let search = window.location.href.split(';').splice(1)
        if (search.length > 0) {
          let queryItems = search
          queryItems.map((queryItem) => {
            if (queryItem) {
              let splitedQueryItem = queryItem.split('=')
              params[splitedQueryItem[0]] = null
              if (splitedQueryItem[1] !== undefined) {
                if (splitedQueryItem[0] === 'continue') {
                  params[splitedQueryItem[0]] = window.atob(decodeURIComponent(splitedQueryItem[1]))
                } else {
                  params[splitedQueryItem[0]] = splitedQueryItem[1]
                }
              }
            }
          })
          // Access Token
          let paramValue = params['access_token']
          if (paramValue) {
            let request = paramValue
            let tempObj = JSON.parse(this.decodeFromBase64Url(request))
            params['isSignedUp'] = tempObj['is_signedup']
            params['email'] = tempObj['email']
            params['oldEmail'] = tempObj['old_email']
            // params['isToResetPassword'] = tempObj['is_reset_password'] // TO BE DELETED
            // dealer_registration
            // dealer_member_invitation
            // site_member_invitation
            // email_change
            // email_change_revoke
            params['request'] = tempObj['request']
          }
          delete params['access_token']
        }
        return Object.keys(params).length > 0 ? this.encodeToBase64Url(JSON.stringify(params)) : null
      },
      encodeToBase64Url: function (str) {
        let base64Str = window.btoa(str)
        var base64Url = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
        return base64Url
      },
      decodeFromBase64Url: function (base64Url) {
        base64Url = decodeURIComponent(base64Url)
        if (base64Url.length % 4 === 2) base64Url = base64Url + '=='
        if (base64Url.length % 4 === 3) base64Url = base64Url + '='
        let base64Str = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        return window.atob(base64Str)
      },
      getParamValue: function (param) {
        let params = {}
        let search = window.location.search
        if (search) {
          let queryItems = search.split('?')[1].split('&')
          queryItems.map((queryItem) => {
            let splitedQueryItem = queryItem.split('=')
            params[splitedQueryItem[0]] = null
            if (splitedQueryItem[1] !== undefined) {
              params[splitedQueryItem[0]] = splitedQueryItem[1]
            }
          })
        }
        return params[param]
      }
    }

    let optionsText = param.getParamValue('options')
    param.options = optionsText ? JSON.parse(window.atob(optionsText)) : {}

    Vue.prototype.$param = param
    Vue.param = param
  }
}

export default ParamPlugin



// WEBPACK FOOTER //
// ./src/plugins/param.js